<template>
  <div class="payment">
    <div class="payment-content" v-if="order">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="payment-clearfix">
          <span>Scan QR Code to Pay</span>
        </div>
        <div class="payment-item">
          <div class="payment-info">
            <p>Order Number: <strong>{{order.order_num}}</strong></p>
            <p>Amount: <strong class="amount-value">{{order.num * order.discount_price}}₹</strong></p>
          </div>
          <div class="qr-code-wrapper" v-if="payUrl">
            <img :src="'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' + encodeURIComponent(payUrl)" alt="QR Code" style="width:250px;height:250px;">
          </div>
          <div class="qr-loading" v-else-if="loadingPayment">
            <i class="el-icon-loading"></i>
            <span>Creating payment...</span>
          </div>
          <div class="qr-tip" v-if="payUrl">
            <p>Please scan the QR code using any UPI payment app</p>
            <p>(Google Pay, PhonePe, Paytm, etc.)</p>
          </div>
          <div class="qr-status" v-if="polling">
            <i class="el-icon-loading"></i>
            <span>Waiting for payment confirmation...</span>
          </div>
          <div class="qr-status success" v-if="paid">
            <i class="el-icon-success"></i>
            <span>Payment successful! Redirecting...</span>
          </div>
          <div class="qr-actions" v-if="payUrl && polling">
            <el-button @click="checkPaymentStatus">I have paid</el-button>
          </div>
        </div>
      </el-card>
    </div>
    <div class="not-found" v-else-if="!loadingOrder">Unable to find the order</div>
  </div>
</template>
<script>
import * as ordersAPI from '@/api/orders'
import * as paymentAPI from '@/api/payment'
export default {
  name: 'Payment',
  data() {
    return {
      orderNum: '',
      order: null,
      loadingOrder: true,
      loadingPayment: false,
      payUrl: '',
      polling: false,
      paid: false,
      pollTimer: null
    }
  },
  activated() {
    if (this.$route.query.orderNum != undefined) {
      this.orderNum = this.$route.query.orderNum
    }
  },
  watch: {
    orderNum: function() {
      this.load()
    }
  },
  beforeDestroy() {
    if (this.pollTimer) { clearInterval(this.pollTimer) }
  },
  methods: {
    load() {
      this.loadingOrder = true
      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200) {
            this.order = res.data
            this.loadingOrder = false
            this.initPayment()
          } else if (res.status === 20001) {
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain order', res.msg)
            this.loadingOrder = false
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain order', err)
          this.loadingOrder = false
        })
    },
    initPayment() {
      this.loadingPayment = true
      paymentAPI
        .initOnlinePayment({
          order_num: String(this.order.order_num),
          amount: String(this.order.num * this.order.discount_price),
          nickname: this.$store.getters.getUser.nickname || 'Customer',
          phone: this.order.address_phone || '',
          email: this.order.address_email || ''
        })
        .then(res => {
          this.loadingPayment = false
          if (res.status === 200 && res.data && res.data.pay_url) {
            this.payUrl = res.data.pay_url
            this.polling = true
            this.startPolling()
          } else if (res.status === 20001) {
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to create payment', res.msg || res.error)
          }
        })
        .catch(err => {
          this.loadingPayment = false
          this.notifyError('Failed to create payment', err)
        })
    },
    startPolling() {
      if (this.pollTimer) clearInterval(this.pollTimer)
      this.pollTimer = setInterval(() => {
        ordersAPI
          .showOrder(this.orderNum)
          .then(res => {
            if (res.status === 200 && res.data && res.data.type === 2) {
              clearInterval(this.pollTimer)
              this.pollTimer = null
              this.polling = false
              this.paid = true
              setTimeout(() => {
                this.notifySucceed('Payment successful!')
                this.$router.push({ path: '/order' })
              }, 1500)
            }
          })
          .catch(() => {})
      }, 5000)
    },
    checkPaymentStatus() {
      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200 && res.data && res.data.type === 2) {
            if (this.pollTimer) { clearInterval(this.pollTimer); this.pollTimer = null }
            this.polling = false
            this.paid = true
            setTimeout(() => {
              this.notifySucceed('Payment successful!')
              this.$router.push({ path: '/order' })
            }, 1500)
          } else {
            this.notifyError('Payment not yet received', 'Please complete the payment and try again')
          }
        })
        .catch(err => {
          this.notifyError('Failed to check payment status', err)
        })
    }
  },
  created() {},
  components: {}
}
</script>

<style scoped>
.payment .payment-content {
  width: 800px;
  margin: 0 auto;
  margin-bottom: 50px;
}
.payment .payment-content .payment-item {
  text-align: center;
}
.payment .payment-content .payment-item .payment-info {
  margin-bottom: 20px;
  font-size: 16px;
  color: #333;
}
.payment .payment-content .payment-item .amount-value {
  font-size: 24px;
  color: #ff6700;
}
.payment .payment-content .payment-item .qr-code-wrapper {
  margin: 20px auto;
}
.payment .payment-content .payment-item .qr-loading,
.payment .payment-content .payment-item .qr-status {
  margin: 20px auto;
  color: #757575;
  font-size: 15px;
}
.payment .payment-content .payment-item .qr-status.success {
  color: #00a724;
}
.payment .payment-content .payment-item .qr-tip {
  margin: 15px auto;
  color: #757575;
  font-size: 14px;
}
.payment .payment-content .payment-item .qr-actions {
  margin-top: 20px;
}
.payment .not-found {
  height: 500px;
  text-align: center;
}
</style>
